const requiredTrimmedString =
  (minLength = 1) =>
  (value) => {
    if (value === undefined || value === null) {
      return "Please provide details.";
    }

    const trimmed = String(value).trim();

    if (trimmed === "") {
      return "Please provide details.";
    }

    if (trimmed.length < minLength) {
      return `Must be at least ${minLength} characters`;
    }

    return true;
  };

const requiredTrimmedNumber = (label) => (value) => {
  if (value === undefined || value === null) {
    return "Please provide details.";
  }

  const trimmed = String(value).trim();

  if (trimmed === "") {
    return "Please provide details.";
  }

  const num = Number(trimmed);
  if (Number.isNaN(num)) {
    return `${label} must be a number`;
  }

  return true;
};

export const locationValidationRules = {
  locationName: {
    validate: requiredTrimmedString(2),
  },

  locationNameTh: {
    validate: requiredTrimmedString(2),
  },

  locationNameEn: {
    validate: requiredTrimmedString(2),
  },

  radius: {
    validate: {
      required: (value) => {
        if (String(value).trim() === "") {
          return "Please provide details.";
        }
        return true;
      },
      positive: (value) => {
        const num = Number(value);
        return num > 0 || "Radius must be greater than 0 meters";
      },
      maxValue: (value) => {
        const num = Number(value);
        return num <= 10000 || "Radius must not exceed 10,000 meters";
      },
    },
  },

  lat: {
    validate: requiredTrimmedNumber("Latitude"),
  },

  long: {
    validate: requiredTrimmedNumber("Longitude"),
  },
};
